import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Page} from '../../models/page';
import {PageService} from "../../services/page.service";

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css']
})
export class PageComponent implements OnInit, OnChanges {

  @Input() pageId: string;// 引用标识
  @Input() totals: number;// 总数
  @Input() showSizeChanger: boolean = true;// 是否显示改变pageSize控件
  @Input() showQuickJumper: boolean = true;// 是否显示快速跳转控件
  @Input() curPage: number;
  @Input() page: Page;

  constructor(private pageSev: PageService) {
  }

  ngOnInit() {
    this.page = new Page();
    this.page.totals = this.totals;
    this.page.pageId = this.pageId;
  }

  pageIndexChange(event) {
    if (event == this.page.pageNo) {
      return;
    }
    this.page.pageNo = event;
    this.pageSev.pageChange.emit(this.page);

  }

  pageSizeChange(event) {
    if (event == this.page.pageSize) {
      return;
    }
    this.page.pageSize = event;
    this.pageSev.pageChange.emit(this.page);
  }

  ngOnChanges(changes: SimpleChanges): void {
    //批量设置分组时控制分页的当前页
    if (changes.curPage && !changes.curPage.firstChange) {
      this.page.pageNo = changes.curPage.currentValue;
    }
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/page/page.component.ts